import { generatePath } from "react-router-dom";

const AuthenticationBase = "/";

const AuthenticationRoutesList = {
  login: `${AuthenticationBase}login`,
  signup: `${AuthenticationBase}signup`,
  profile: `${AuthenticationBase}profile`,
  redirectUrlAfterLogin: `${AuthenticationBase}login?next=:nextUrl`,
  confirmEmail: `${AuthenticationBase}confirm-email`,
  forgotPassword: `${AuthenticationBase}forgot-password`,
  // Updated to include token parameter
  resetPassword: `${AuthenticationBase}reset-password/:token`,
};

const AuthenticationRoutesGenerators = {
  redirectAfterLogin: (nextUrl) =>
    generatePath(AuthenticationRoutesList.redirectUrlAfterLogin, {
      nextUrl: nextUrl,
    }),
  // Add generator for reset password with token
  resetPasswordWithToken: (token) =>
    generatePath(AuthenticationRoutesList.resetPassword, {
      token: token,
    }),
};

export const AuthenticationRoutes = {
  ...AuthenticationRoutesList,
  ...AuthenticationRoutesGenerators,
};
